// ============================================
// HERO COMPONENT - Shrileela Beach Resort
// ============================================

const Hero = ({ onBookNow }) => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 75, behavior: 'smooth' });
  };

   const handleBookNow = () => {
   
    if (onBookNow) onBookNow();
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400;1,700&family=Jost:wght@300;400;500&display=swap');

        .hero-section {
          position: relative;
          height: 100vh;
          min-height: 600px;
          display: flex;
          align-items: center;
          overflow: hidden;
          font-family: 'Jost', sans-serif;
        }
        .hero-bg {
          position: absolute;
          inset: 0;
          background: url('https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1600&q=85') center/cover no-repeat;
          transform: scale(1.08);
          animation: slowZoom 18s ease-in-out infinite alternate;
        }
        @keyframes slowZoom { from { transform: scale(1.08); } to { transform: scale(1.0); } }
        .hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(20,40,20,0.75) 0%, rgba(10,25,15,0.55) 50%, rgba(0,0,0,0.3) 100%);
        }
        .hero-overlay2 {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 200px;
          background: linear-gradient(to top, rgba(0,0,0,0.4), transparent);
        }

     .hero-content {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 72px 24px 0;  /* ← add top padding equal to navbar height */
  width: 100%;
}
        .hero-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,255,255,0.12);
          backdrop-filter: blur(8px);
          border: 1px solid rgba(255,255,255,0.2);
          padding: 8px 18px;
          border-radius: 40px;
          color: #a8d5a2;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 28px;
          animation: fadeUp 0.8s ease 0.2s both;
        }
        .hero-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(48px, 8vw, 90px);
          font-weight: 700;
          color: #fff;
          line-height: 1.05;
          margin: 0 0 8px;
          animation: fadeUp 0.8s ease 0.4s both;
        }
        .hero-title-italic {
          font-style: italic;
          color: #a8d5a2;
        }
        .hero-subtitle {
          font-size: clamp(16px, 2.5vw, 20px);
          color: rgba(255,255,255,0.82);
          font-weight: 300;
          line-height: 1.7;
          max-width: 560px;
          margin: 20px 0 40px;
          animation: fadeUp 0.8s ease 0.6s both;
        }
        .hero-cta-row {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
          animation: fadeUp 0.8s ease 0.8s both;
        }
        .hero-btn-primary {
          background: #3d5a3e;
          color: #fff;
          border: none;
          padding: 16px 36px;
          border-radius: 40px;
          font-family: 'Jost', sans-serif;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
          cursor: pointer;
          transition: all 0.3s;
          box-shadow: 0 8px 30px rgba(61,90,62,0.5);
        }
        .hero-btn-primary:hover { background: #2d4230; transform: translateY(-2px); box-shadow: 0 14px 40px rgba(61,90,62,0.5); }
        .hero-btn-secondary {
          background: transparent;
          color: #fff;
          border: 2px solid rgba(255,255,255,0.5);
          padding: 14px 34px;
          border-radius: 40px;
          font-family: 'Jost', sans-serif;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 1px;
          cursor: pointer;
          transition: all 0.3s;
        }
        .hero-btn-secondary:hover { border-color: #fff; background: rgba(255,255,255,0.1); transform: translateY(-2px); }

        .hero-stats {
          display: flex;
          gap: 48px;
          margin-top: 64px;
          padding-top: 32px;
          border-top: 1px solid rgba(255,255,255,0.15);
          animation: fadeUp 0.8s ease 1s both;
          flex-wrap: wrap;
        }
        .hero-stat-num {
          font-family: 'Playfair Display', serif;
          font-size: 36px;
          font-weight: 700;
          color: #a8d5a2;
          line-height: 1;
        }
        .hero-stat-label {
          font-size: 13px;
          color: rgba(255,255,255,0.65);
          margin-top: 4px;
          font-weight: 400;
          letter-spacing: 0.5px;
        }

        .hero-scroll {
          position: absolute;
          bottom: 36px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          color: rgba(255,255,255,0.5);
          font-size: 11px;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          animation: bounce 2s ease infinite;
        }
        .scroll-mouse {
          width: 26px;
          height: 42px;
          border: 2px solid rgba(255,255,255,0.35);
          border-radius: 14px;
          display: flex;
          justify-content: center;
          padding-top: 8px;
        }
        .scroll-dot {
          width: 4px;
          height: 8px;
          background: rgba(255,255,255,0.5);
          border-radius: 2px;
          animation: scrollAnim 1.5s ease infinite;
        }
        @keyframes scrollAnim { 0%,100% { transform: translateY(0); opacity: 1; } 50% { transform: translateY(8px); opacity: 0.3; } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes bounce { 0%,100% { transform: translateX(-50%) translateY(0); } 50% { transform: translateX(-50%) translateY(-6px); } }

        .hero-location-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: rgba(255,255,255,0.7);
          font-size: 13px;
          margin-bottom: 16px;
          animation: fadeUp 0.8s ease 0.1s both;
        }

        @media (max-width: 600px) {
          .hero-stats { gap: 28px; }
          .hero-cta-row { flex-direction: column; }
          .hero-btn-primary, .hero-btn-secondary { text-align: center; width: 100%; max-width: 280px; }
        }

@media (max-width: 600px) {
  .hero-content {
    padding-top: 80px;  /* a touch more breathing room on mobile */
  }
  .hero-stats { gap: 28px; }
  .hero-cta-row { flex-direction: column; }
  .hero-btn-primary, .hero-btn-secondary { text-align: center; width: 100%; max-width: 280px; }
}

      `}</style>

      <section id="home" className="hero-section">
        <div className="hero-bg" />
        <div className="hero-overlay" />
        <div className="hero-overlay2" />

        <div className="hero-content">
          {/* <div className="hero-location-badge">
            <span>📍</span>
            <span>Murud Beach, Tal. Dapoli, Dist. Ratnagiri</span>
          </div> */}

          {/* <div className="hero-tag">
            <span>🌴</span>
            <span>Chaitul Hospitality LLP</span>
          </div> */}

          <h1 className="hero-title">
            Shrileela<br />
            <span className="hero-title-italic">Beach Resort</span>
          </h1>

          <p className="hero-subtitle">
            Wake up to the sound of waves at Murud Beach. An affordable beachside retreat where nature, comfort, and coastal charm come together.
          </p>

          <div className="hero-cta-row">
            <button className="hero-btn-primary" onClick={handleBookNow}>
              Book Your Stay
            </button>
            <button className="hero-btn-secondary" onClick={() => scrollTo('rooms')}>
              Explore Rooms
            </button>
          </div>

          <div className="hero-stats">
            <div>
              <div className="hero-stat-num">₹2000</div>
              <div className="hero-stat-label">Rooms from / night</div>
            </div>
            <div>
              <div className="hero-stat-num">4+</div>
              <div className="hero-stat-label">Room Types</div>
            </div>
            <div>
              <div className="hero-stat-num">4.8★</div>
              <div className="hero-stat-label">Guest Rating</div>
            </div>
            <div>
              <div className="hero-stat-num">24/7</div>
              <div className="hero-stat-label">Service</div>
            </div>
          </div>
        </div>

        <div className="hero-scroll">
          <div className="scroll-mouse">
            <div className="scroll-dot" />
          </div>
          <span>Scroll</span>
        </div>
      </section>
    </>
  );
};

export default Hero;